// Shared Firebase configuration
// This file centralizes Firebase config to avoid duplication across components

export const getFirebaseConfig = () => {
  return typeof __firebase_config !== 'undefined' 
    ? JSON.parse(__firebase_config) 
    : { 
        apiKey: "AIzaSyB13UYteewVEw-XtZSn953bg-AEqDFd3Q8",
        authDomain: "perai-1eb6b.firebaseapp.com",
        projectId: "perai-1eb6b",
        storageBucket: "perai-1eb6b.firebasestorage.app",
        messagingSenderId: "1037439152530",
        appId: "1:1037439152530:web:8a23448560da9da1a1d14b",
        measurementId: "G-K517HX3SHJ"
      };
};

export const getAppId = () => {
  return typeof __app_id !== 'undefined' ? __app_id : 'perai-default';
};

